import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { venueInfo } from "../lib/i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const FALLBACK_CONTACT = {
  address: venueInfo.address,
  phone: venueInfo.phone,
  email: venueInfo.email,
  maps_url: venueInfo.mapsUrl,
  instagram: venueInfo.social.instagram,
  facebook: venueInfo.social.facebook,
};

export const useContact = () => {
  const [contact, setContact] = useState(FALLBACK_CONTACT);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API}/settings/contact`);
      const data = res.data || {};
      setContact({
        address: data.address || FALLBACK_CONTACT.address,
        phone: data.phone || FALLBACK_CONTACT.phone,
        email: data.email || FALLBACK_CONTACT.email,
        maps_url: data.maps_url || FALLBACK_CONTACT.maps_url,
        instagram: data.instagram || FALLBACK_CONTACT.instagram,
        facebook: data.facebook || FALLBACK_CONTACT.facebook,
      });
    } catch (e) {
      setContact(FALLBACK_CONTACT);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { contact, loading, refresh };
};
